import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removewhitespaces',
    standalone: false
})
export class RemoveWhiteSpace implements PipeTransform {

  transform(value: string, args?: any): string {
    return value.replace(/ /g, '');
  }

}
